import { render, staticRenderFns } from "./featuresPage.vue?vue&type=template&id=7b9ac730&scoped=true"
import script from "./featuresPage.vue?vue&type=script&lang=js"
export * from "./featuresPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ac730",
  null
  
)

export default component.exports